<template>
    <div class="cooperatepop">
        <div class="pop_close" @click="popclose">
            <img v-if="theme === 2" src="@/assets/popcloseW.svg">
            <img v-else src="@/assets/popcloseB.svg">
        </div>
        <img class="img1" :src="wxurl" alt="">
    </div>
</template>

<script setup>
import { onMounted, computed, defineEmits, ref } from 'vue'
import { useStore } from 'vuex'
const store = useStore()

const theme = computed(() => { return store.state.app.theme })

const emit = defineEmits(['updateData'])
const popclose = () => {
    emit('popclose')
}

const wxurl = ref(null)
wxurl.value = process.env.VUE_APP_PIC_URL + '/alanNotes/alan.png'
</script>

<style lang="scss" scoped>
.cooperatepop {
    width: 20rem;
    height: 20rem;
    border-radius: 1rem;
    background: var(--aboutpop-bac);
    border: 1px solid var(--carditem-item-border1);
    position: absolute;
    top: 5rem;
    right: 16rem;
    animation: popin .7s ease-in forwards;
    display: flex;
    justify-content: center;
    align-items: center;

    .img1 {
        width: 80%;
        height: 80%;
        border-radius: 1rem;
    }
}
</style>